<app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>

<div
	class="row"
	*ngIf="loading">
	<div class="col text-center">
		<app-loader [material]="false"></app-loader>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && employee">
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="tab-card">

			<nav
				ngbNav
				[navsetlink]="nav"
				#nav="ngbNav"
				class="nav-tabs">
				<ng-container
					ngbNavItem="datipersonali"
					id="1">
					<a
						routerLink="."
						fragment="datipersonali"
						ngbNavLink>
						Dati Personali
					</a>
					<ng-template ngbNavContent>

						<table
							class="table"
							*ngIf="employee">
							<tbody>
								<tr *ngIf="employee.id">
									<td>{{ 'labels.id' | translate }}</td>
									<td>{{ employee.id }}</td>
								</tr>
								<tr *ngIf="employee.fname">
									<td>{{ 'labels.fname' | translate }}</td>
									<td>{{ employee.fname }}</td>
								</tr>
								<tr *ngIf="employee.lname">
									<td>{{ 'labels.lname' | translate }}</td>
									<td>{{ employee.lname }}</td>
								</tr>

								<tr *ngIf="employee.email">
									<td>{{ 'labels.email' | translate }}</td>
									<td>{{ employee.email }}</td>
								</tr>
								<tr *ngIf="employee.birthdate">
									<td>{{'labels.birthdate' | translate }}</td>
									<td>
										{{ employee.birthdate | date:'dd/MM/yyyy'}}
									</td>
								</tr>

								<tr *ngIf="employee.birthcity">
									<td>{{ 'labels.birthcity' | translate }}</td>
									<td>{{ employee.birthcity }}</td>
								</tr>

								<tr *ngIf="employee.cf">
									<td>{{ 'labels.cf' | translate }}</td>
									<td>{{ employee.cf }}</td>
								</tr>

								<tr>
									<td>{{ 'labels.gender' | translate }}</td>
									<td>{{ employee.gender }}</td>
								</tr>

								<tr *ngIf="employee.studylevel">
									<td>{{ 'labels.studylevel' | translate }}</td>
									<td>{{ employee.studylevel }}</td>
								</tr>

								<tr *ngIf="employee.studysubject">
									<td>{{ 'labels.studysubject' | translate }}</td>
									<td>{{ employee.studysubject }}</td>
								</tr>
								<tr *ngIf="employee.jobposition">
									<td>{{ 'labels.jobposition' | translate }}</td>
									<td>{{ employee.jobposition }}</td>
								</tr>

								<tr *ngIf="employee.jobdescription">
									<td>
										{{ 'labels.jobdescription' | translate }}
									</td>
									<td>{{ employee.jobdescription }}</td>
								</tr>

								<tr *ngIf="employee.company">
									<td>{{'labels.company' | translate }}</td>
									<td>
										<a
											class="link"
											routerLink="/company/view/{{employee.company.id}}">
											{{ employee.company.name }}
										</a>
									</td>
								</tr>
								<tr>
									<td>{{ 'labels.ispartner' | translate }}</td>
									<td>{{ employee.partner ? 'SI': 'NO' }}</td>
								</tr>
								<tr *ngIf="employee.contract">
									<td>{{ 'labels.contracttype' | translate }}</td>
									<td>{{ employee.contract}}</td>
								</tr>

								<tr *ngIf="employee.contractlevel">
									<td>
										{{ 'labels.contractlevel' | translate }}
									</td>
									<td>{{ employee.contractlevel }}</td>
								</tr>

								<tr *ngIf="employee.country">
									<td>{{ 'labels.country' | translate }}</td>
									<td>{{ employee.country }}</td>
								</tr>

								<tr *ngIf="employee.province">
									<td>{{ 'labels.province' | translate }}</td>
									<td>{{ employee.province }}</td>
								</tr>
								<tr *ngIf="employee.city">
									<td>{{ 'labels.city' | translate }}</td>
									<td>{{ employee.city }}</td>
								</tr>

								<tr *ngIf="employee.zipcode">
									<td>{{ 'labels.zipcode' | translate }}</td>
									<td>{{ employee.zipcode }}</td>
								</tr>

								<tr *ngIf="employee.address">
									<td>{{ 'labels.address' | translate }}</td>
									<td>
										{{ employee.address }} {{ employee.streetno }}
									</td>
								</tr>

								<tr *ngIf="employee.landline">
									<td>{{ 'labels.landline' | translate }}</td>
									<td>{{ employee.landline }}</td>
								</tr>

								<tr *ngIf="employee.mobileno">
									<td>{{ 'labels.mobileno' | translate }}</td>
									<td>{{ employee.mobileno}}</td>
								</tr>
								<tr *ngIf="employee.expyears">
									<td>{{ 'employee.expyears' |translate }}</td>
									<td>{{ employee.expyears }}</td>
								</tr>

								<tr *ngIf="employee.insdate">
									<td>{{'labels.insdate' | translate }}</td>
									<td>
										{{ employee.insdate | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
								</tr>
								<tr *ngIf="employee.moddate">
									<td>{{'labels.moddate' | translate }}</td>
									<td>
										{{ employee.moddate | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
								</tr>

								<div class="row mt-1">
									<div class="col">
										<button
											(click)="editPersonal()"
											class="btn btn-primary">
											{{'labels.edit' | translate}}
										</button>
									</div>
								</div>

							</tbody>
						</table>

					</ng-template>
				</ng-container>
				<ng-container
					*ngIf="showcosts"
					ngbNavItem="datisalariali">
					<a
						routerLink="."
						fragment="datisalariali"
						ngbNavLink>
						Dati Salariali
					</a>
					<ng-template ngbNavContent>
						<table
							class="table"
							*ngIf="employee">
							<tbody>
								<tr *ngIf="employee.etype">
									<td>{{'labels.type' | translate }}</td>
									<td>
										{{'labels.' + employee.etype | translate}}
									</td>
								</tr>

								<tr *ngIf="employee.joindate">
									<td>{{'employee.joindate' | translate }}</td>
									<td>
										{{ employee.joindate | date:'dd/MM/yyyy'}}
									</td>
								</tr>

								<tr *ngIf="employee.basesalary">
									<td>{{ 'employee.basesalary' | translate }}</td>
									<td>{{ employee.basesalary }}</td>
								</tr>

								<tr *ngIf="employee.contracthour">
									<td>
										{{ 'employee.contracthour' | translate }}
									</td>
									<td>{{ employee.contracthour }}</td>
								</tr>

								<tr *ngIf="employee.contractleave">
									<td>
										{{ 'employee.contractleave' | translate }}
									</td>
									<td>{{ employee.contractleave }}</td>
								</tr>

								<tr *ngIf="employee.hourlycost">
									<td>{{ 'employee.hourlycost' | translate }}</td>
									<td>
										{{ employee.hourlycost | currency:'EUR'}}
									</td>
								</tr>

								<tr *ngIf="employee.inail">
									<td>{{ 'employee.inail' | translate }}</td>
									<td>{{ employee.inail}}</td>
								</tr>

								<tr *ngIf="employee.inps">
									<td>{{ 'employee.inps' | translate }}</td>
									<td>{{ employee.inps }}</td>
								</tr>

								<tr *ngIf="employee.oneri">
									<td>{{ 'employee.oneri' | translate }}</td>
									<td>{{ employee.oneri }}</td>
								</tr>

								<tr *ngIf="employee.payurl">
									<td>{{ 'employee.payurl' | translate }}</td>
									<td>{{ employee.payurl }}</td>
								</tr>

								<tr *ngIf="employee.rateo">
									<td>{{ 'employee.rateo' | translate }}</td>
									<td>{{ employee.rateo }}</td>
								</tr>

								<tr *ngIf="employee.yearlyhour">
									<td>{{ 'employee.yearlyhour' | translate }}</td>
									<td>{{ employee.yearlyhour }}</td>
								</tr>

								<tr *ngIf="employee.yearlysalary">
									<td>
										{{ 'employee.yearlysalary' | translate }}
									</td>
									<td>{{ employee.yearlysalary }}</td>
								</tr>

								<div class="row mt-1">
									<div class="col">
										<button
											(click)="editSalary()"
											class="btn btn-primary">
											{{'labels.edit' | translate}}
										</button>
									</div>
								</div>

							</tbody>
						</table>

					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="documenti">
					<a
						routerLink="."
						fragment="documenti"
						ngbNavLink>
						Documenti
					</a>
					<ng-template ngbNavContent>
						<app-attachments
							[extradata]="{'company' : employee.companyid}"
							[card]="false"
							mediapath="download"
							[library]="true"
							entity="employee"
							[bootstrap]="true"
							(change)="attachmentsChanged()"
							[canvalidate]="canvalidate"
							[eid]="employee.id">
						</app-attachments>
					</ng-template>
				</ng-container>

				<ng-container ngbNavItem="moduli">
					<a
						routerLink="."
						fragment="moduli"
						ngbNavLink>
						Moduli
					</a>
					<ng-template ngbNavContent>
						<app-doc-template-generate
							[entityname]="employee.fullname"
							entity="employee"
							[eid]="employee.id"></app-doc-template-generate>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="presenze">
					<a
						routerLink="."
						fragment="presenze"
						ngbNavLink>
						Presenze
					</a>
					<ng-template ngbNavContent>
						<app-timesheet-grid [employee]="employee"></app-timesheet-grid>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="inserimentoore">
					<a
						routerLink="."
						fragment="inserimentoore"
						ngbNavLink>
						Inserimento Ore
					</a>
					<ng-template ngbNavContent>
						<app-employee-precenceupdate [employee]="employee"></app-employee-precenceupdate>
					</ng-template>
				</ng-container>
			</nav>

			<div
				[ngbNavOutlet]="nav"
				class="mt-2"></div>
		</app-card>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && error">
	<div class="col-sm-12">
		<app-card [hidHeader]="true">
			{{'errors.loading.employee' | translate}}
		</app-card>

	</div>
</div>
